import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import TextInput from './TextInput'

class PasswordInput extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      value1: props.value || '',
      value2: props.value || '',
      fieldRef1: null,
      fieldRef2: null
    }

    // Bind events
    this.onChange1 = this.onChange1.bind(this)
    this.onChange2 = this.onChange2.bind(this)
    this.setRef1 = this.setRef1.bind(this)
    this.setRef2 = this.setRef2.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When a value changes
    if (
      prevState.value1 !== this.state.value1
      ||
      prevState.value2 !== this.state.value2
    ) {
      // Determine if passwords are matching
      const isValid = (
        !_.isString(this.props.label2) // not double-checking
        ||
        this.state.value1 === this.state.value2
      )

      // Bubble local change to parent
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.value1, isValid)
      }
    }

    // Bubble parent change to local
    if (prevProps.value !== this.props.value) {
      this.setState({
        value1: this.props.value,
        value2: this.props.value
      })
    }

    // Bubble ref changes to parent
    if (
      prevState.fieldRef1 !== this.state.fieldRef1
      &&
      _.isFunction(this.props.fieldRef1)
    ) {
      this.props.fieldRef1(this.state.fieldRef1)
    }
    if (
      prevState.fieldRef2 !== this.state.fieldRef2
      &&
      _.isFunction(this.props.fieldRef2)
    ) {
      this.props.fieldRef2(this.state.fieldRef2)
    }
  }

  onChange1(value) {
    this.setState({
      value1: value
    })
  }

  onChange2(value) {
    this.setState({
      value2: value
    })
  }

  setRef1(fieldRef1) {
    this.setState({
      fieldRef1
    })
  }

  setRef2(fieldRef2) {
    this.setState({
      fieldRef2
    })
  }

  render() {
    const { label1, label2, value, onChange, error, type, ...props } = this.props
    return (
      <React.Fragment>
        <TextInput
          type='password'
          label={label1}
          value={this.state.value1}
          onChange={this.onChange1}
          error={error}
          fieldRef={this.setRef1}
          {...props}
        />
        {
          _.isString(label2)
            ? <TextInput
                type='password'
                label={label2}
                value={this.state.value2}
                onChange={this.onChange2}
                error={
                  this.state.value1 === this.state.value2
                    ? undefined
                    : 'Les deux mots de passe ne correspondent pas'
                }
                fieldRef={this.setRef2}
                {...props}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

PasswordInput.propTypes = {
  label1: PropTypes.string, // if missing, rendered without Form structure
  label2: PropTypes.string, // if missing, no double verification
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  fieldRef1: PropTypes.func,
  fieldRef2: PropTypes.func
}

export default PasswordInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/PasswordInput.js